//スムーススクロール
// $(function(){
// 	$('a[href^="#"]').click(function() {
//     var speed = 400; // ミリ秒で記述
//     var href= $(this).attr("href");
//     var target = $(href == "#" || href == "" ? 'html' : href);
//     var position = target.offset().top - 160;
//     $('body,html').animate({scrollTop:position}, speed, 'swing');
//       return false;
//   });
// });

//ハンバーガーメニュー
$(function() {
  $(document).on("click", ".c-header__navToggle", function() {
    $(".c-header__navToggle").toggleClass("u-active");
    $(".c-header__nav__container").toggleClass("u-active");
    $(".c-globalmenu__bg").toggleClass("u-active");
  });

  $(".c-header__nav__list a").on("click", function() {
    if (window.innerWidth <= 768) {
      $(".c-header__navToggle").click();
    }
  });
});

//アコーディオン
$(function() {
  $(".js-accordion_toggle").on("click", function() {
    $(this).toggleClass("u-active");
    $(this)
      .parent()
      .next(".js-accordion_content")
      .slideToggle();
  });
});

$(function() {
  var heightadjust = function() {
    var maxHeight = 0;
    $('.p-recipe__article').each(function(idx, elem) {
      var height = $(elem).height();
      if(maxHeight < height) {
        maxHeight = height;
      }
    });
    $('.p-recipe__article').height(maxHeight);
  };

  if (window.innerWidth > 768) {
    $(window).on('load resize', function () {
      heightadjust();
    });
  }
});

$(function() {
  $('[name="agree"]').change(function(){
    if ($(this).prop('checked')) {
      $('.js-agree').removeClass('c-btn-disabled');
      $(".js-agree").prop("disabled", false);
    } else {
      $('.js-agree').addClass('c-btn-disabled');
      $(".js-agree").prop("disabled", true);
    }
  });
  $('[name="agree-newsletter"]').change(function(){
    if ($(this).prop('checked')) {
      $('.js-agree-newsletter').removeClass('c-btn-disabled');
      $(".js-agree-newsletter").prop("disabled", false);
    } else {
      $('.js-agree-newsletter').addClass('c-btn-disabled');
      $(".js-agree-newsletter").prop("disabled", true);
    }
  });
});

// ALL COLLECTON の並び替え
$(function() {
  var $arr = $('.js-sortAllCollection .c-all_collections__item').sort(function(a, b){
    return ($(a).text() > $(b).text() ? 1 : -1);  //ソート条件
  });

  $('.js-sortAllCollection').html("");
  $arr.each(function(){
    $('.js-sortAllCollection').append($(this)).css({'opacity':1});
  });
});